"use strict";
import { useMemo } from "react";
import { Dashboard } from "capitalrx-types";
export function useMenuGroups(items, itemsPerRow) {
  return useMemo(() => {
    var _a, _b;
    const result = [];
    const groupTable = {};
    const groupIds = [];
    for (const item of items) {
      const { data } = item;
      const { group } = data;
      const actualGroup = (_a = Dashboard.NavigationGroup[group == null ? void 0 : group.id]) != null ? _a : Dashboard.NavigationGroup.Unknown;
      if (!groupTable[actualGroup.id]) {
        groupTable[actualGroup.id] = [];
        groupIds.push(actualGroup.id);
      }
      (_b = groupTable[group.id]) == null ? void 0 : _b.push(item);
    }
    const sortedGroupIds = groupIds.sort((a, b) => Dashboard.NavigationGroupMenuOrder[a] - Dashboard.NavigationGroupMenuOrder[b]);
    let counter = 0;
    for (const groupId of sortedGroupIds) {
      const items2 = groupTable[groupId];
      if (!items2) continue;
      const index = counter % itemsPerRow;
      if (!result[index]) {
        result[index] = [{ id: groupId, items: items2 }];
      } else {
        result[index].push({ id: groupId, items: items2 });
      }
      counter++;
    }
    return result;
  }, [items, itemsPerRow]);
}
